import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import HomeSaleProceedsCalculator from "./HomeSaleProceedsCalculator.esm.js";
import { FieldConfig } from "./HomeSaleProceedsCalculator.utils.esm.js";
const HomeSaleProceedsCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      desiredSellingPrice,
      remainingMortgageOwed,
      homeImprovement,
      cleaningAndPrep,
      monthlyMortgagePayments,
      moving,
      agentCommission,
      sellingConcessions,
      closingFees,
      taxes
    } = attrs;
    const defaultValues = {
      desiredSellingPrice,
      remainingMortgageOwed,
      homeImprovement,
      cleaningAndPrep,
      monthlyMortgagePayments,
      moving,
      agentCommission,
      sellingConcessions,
      closingFees,
      taxes
    };
    return /* @__PURE__ */ jsx(HomeSaleProceedsCalculator, { ...{
      defaultValues
    } }, isEditor() ? JSON.stringify(defaultValues) : void 0);
  },
  metadata: {
    version: "1.0",
    name: "constellation/home-sale-proceeds-calculator",
    title: "Home Sale Proceeds Calculator",
    description: "Estimates how much money you will make selling your home.",
    icon: "calculator",
    keywords: ["home", "sale", "proceeds", "calculator"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "more",
    attributes: {
      [FieldConfig.desiredSellingPrice.name]: {
        type: "number",
        default: 302e3,
        label: "Selling price & mortgage : default desired selling price",
        control: "number"
      },
      [FieldConfig.remainingMortgageOwed.name]: {
        type: "number",
        default: 0,
        label: "Selling price & mortgage : default remaining mortgage owed",
        control: "number"
      },
      [FieldConfig.homeImprovement.name]: {
        type: "number",
        label: "Est. prep & repair costs : default home improvement",
        default: 0,
        control: "number"
      },
      [FieldConfig.cleaningAndPrep.name]: {
        type: "number",
        label: "Est. prep & repair costs : default cleaning and prep",
        default: 6e3,
        control: "number"
      },
      [FieldConfig.monthlyMortgagePayments.name]: {
        type: "number",
        default: 0,
        label: "Est. on-market costs : default monthly mortgage payments",
        control: "number"
      },
      [FieldConfig.moving.name]: {
        type: "number",
        default: 1600,
        label: "Est. on-market costs: default moving",
        control: "number"
      },
      [FieldConfig.agentCommission.name]: {
        type: "number",
        default: 0,
        label: "Est. closing costs: default agent commission",
        control: "number"
      },
      [FieldConfig.sellingConcessions.name]: {
        type: "number",
        default: 0,
        label: "Est. closing costs: default selling concessions",
        control: "number"
      },
      [FieldConfig.closingFees.name]: {
        type: "number",
        default: 0,
        label: "Est. closing costs: default closing fees",
        control: "number"
      },
      [FieldConfig.taxes.name]: {
        type: "number",
        default: 0,
        label: "Est. closing costs: default taxes",
        control: "number"
      }
    }
  }
};
export {
  HomeSaleProceedsCalculatorBlock as default
};
